import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { dashboardRequest } from "../providers/aws/client";
import {
  incidentListPath,
  incidentSummaryPath,
  shouldRetryIncidents,
} from "./incidentsModel";
import type {
  EchoIncidentList,
  EchoIncidentSummary,
  IncidentListState,
} from "./types";

/** The Incidents tab polls once a minute; the sweep that opens overdue incidents runs every minute too. */
export const INCIDENTS_REFRESH_MS = 60_000;

// Both query-key prefixes are excluded from the persisted query cache
// (root/persistQueryFilter.ts): the rows carry customer names and are live
// monitoring state that must never be served from a previous session.

export function useIncidentList(state: IncidentListState, days: number) {
  return useQuery({
    queryKey: ["echo-incidents", state, days],
    queryFn: ({ signal }) =>
      dashboardRequest<EchoIncidentList>(incidentListPath(state, days), {
        signal,
        cache: "no-store",
      }),
    staleTime: 30_000,
    refetchInterval: INCIDENTS_REFRESH_MS,
    refetchIntervalInBackground: false,
    placeholderData: keepPreviousData,
    retry: shouldRetryIncidents,
  });
}

export function useIncidentSummary(days: number, weeks: number) {
  return useQuery({
    queryKey: ["echo-incidents-summary", days, weeks],
    queryFn: ({ signal }) =>
      dashboardRequest<EchoIncidentSummary>(incidentSummaryPath(days, weeks), {
        signal,
        cache: "no-store",
      }),
    staleTime: 30_000,
    refetchInterval: INCIDENTS_REFRESH_MS,
    refetchIntervalInBackground: false,
    placeholderData: keepPreviousData,
    retry: shouldRetryIncidents,
  });
}
